import Rules from './Rules';

export default {
  __init__: [ 'rules' ],
  rules: [ 'type', Rules ]
};
